import React from 'react';
import type { GuestReservationFormProps } from './guestReservationFormTypes';
import { GuestReservationFormSuccessView } from './GuestReservationFormSuccessView';
import { GuestReservationFormView } from './GuestReservationFormView';
import { useGuestReservationForm } from './useGuestReservationForm';

const GuestReservationForm: React.FC<GuestReservationFormProps> = (props) => {
  const m = useGuestReservationForm(props);

  if (!m.isOpen) return null;

  if (m.isSubmitted && m.submittedReservationId) {
    return (
      <GuestReservationFormSuccessView
        t={m.t}
        confirmationTemplate={m.confirmationTemplate}
        submittedReservationData={m.submittedReservationData}
        submittedReservationId={m.submittedReservationId}
        cloverCharge={m.cloverCharge}
        accountCreationStatus={m.accountCreationStatus}
        accountCreationError={m.accountCreationError}
        onRetryAccountCreation={m.retryAccountCreation}
        onCloseSuccess={m.resetAfterSuccessClose}
      />
    );
  }

  return <GuestReservationFormView m={m} />;
};

export default GuestReservationForm;
